import { ModalCustom } from "components/ModalCustom";
import { ModalButton } from "components/ModalCustom/style";
import { formatarDinheiro } from "_utils/Money";
import { IDebitoIpva } from "../../interfaces/IDebitoIpva";
import { AlertBox, FooterActions, InfoRow, InfoItem } from "./style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";

interface IProps {
  show: boolean;
  selectedRows: IDebitoIpva[];
  handleClose: () => void;
  onConfirm: () => void;
}

export function ModalConfirmarLote({
  show,
  selectedRows,
  handleClose,
  onConfirm,
}: IProps) {
  const totalValor = selectedRows.reduce((acc, d) => acc + Number(d.valor ?? 0), 0);
  const count = String(selectedRows.length).padStart(2, "0");

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Pagar IPVA"
      centered
      footer
      size="lg"
      footerTools={
        <FooterActions>
          <ModalButton outline variante="primary" onClick={handleClose}>
            Cancelar
          </ModalButton>
          <ModalButton onClick={onConfirm}>Confirmar pagamento</ModalButton>
        </FooterActions>
      }
    >
      <AlertBox>
        <FontAwesomeIcon icon={faCircleExclamation} />
        Confira as informações abaixo antes de confirmar o pagamento.
      </AlertBox>
      <InfoRow>
        <InfoItem>
          <small>Débitos</small>
          <strong>{count}</strong>
        </InfoItem>
        <InfoItem>
          <small>Valor total</small>
          <strong>{formatarDinheiro(totalValor)}</strong>
        </InfoItem>
      </InfoRow>
      <p style={{ marginTop: 20, fontSize: 15 }}>
        Deseja confirmar o pagamento dos débitos selecionados?
      </p>
    </ModalCustom>
  );
}
